import React from "react";
import {
  AppBar,
  Paper,
  Toolbar,
  Typography,
  Button,
  makeStyles,
  IconButton,
  Menu,
  MenuItem,
  Container,
  Hidden,
  Box,
  Divider,
  ListItemIcon,
  Switch,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import PhoneIcon from "@material-ui/icons/Phone";
import EmailIcon from "@material-ui/icons/Email";
import HomeIcon from "@material-ui/icons/Home";
import ServicesIcon from "@material-ui/icons/Build";
import SubjectsIcon from "@material-ui/icons/Book";
import ContactIcon from "@material-ui/icons/ContactMail";
import { useTheme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: theme.palette.type === "dark" ? "#000" : "#f5f5f5", // Updated to #000 for dark theme
  },
  paperContainer: {
    marginBottom: theme.spacing(1),
  },
  toolbar: {
    minHeight: "120px",
  },
  menuButton: {
    marginRight: theme.spacing(2),
    color: theme.palette.type === "dark" ? "#fff" : "#333333",
  },
  logo: {
    marginRight: theme.spacing(2),
    height: "100px",
  },
  title: {
    flexGrow: 1,
    color: theme.palette.type === "dark" ? "#fff" : "#333333",
    fontWeight: "bold",
    cursor: "pointer",
  },
  navButton: {
    textTransform: "none",
    fontWeight: "bold",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    color: theme.palette.type === "dark" ? "#fff" : "#333333",
    "&:hover": {
      color: "#8601af",
      borderBottom: "2px solid #8601af",
    },
  },
  contactInfo: {
    display: "flex",
    alignItems: "center",
    marginLeft: theme.spacing(2),
  },
  contactIcon: {
    marginRight: theme.spacing(1),
    color: "#8601af",
  },
  contactText: {
    color: theme.palette.type === "dark" ? "#fff" : "#333333",
  },
  divider: {
    height: "30px",
    margin: theme.spacing(0, 2),
    backgroundColor: theme.palette.type === "dark" ? "#555" : "#e0e0e0",
  },
  menuItem: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    padding: theme.spacing(1, 2),
    "&:hover": {
      backgroundColor: theme.palette.type === "dark" ? "#333" : "#f5f5f5",
    },
  },
  menuIcon: {
    marginRight: theme.spacing(1),
    color: "#8601af",
  },
  darkModeToggle: {
    marginLeft: theme.spacing(2),
  },
}));

const Header = ({ isDarkMode, toggleDarkMode }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={classes.root}>
      <Paper elevation={3} className={classes.paperContainer}>
        <AppBar className={classes.appBar} elevation={0} position="sticky">
          <Container>
            <Toolbar className={classes.toolbar}>
              <Hidden mdUp>
                <IconButton
                  edge="start"
                  className={classes.menuButton}
                  onClick={handleMenuClick}
                >
                  <MenuIcon />
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuClose}
                >
                  <MenuItem
                    onClick={handleMenuClose}
                    className={classes.menuItem}
                  >
                    <ListItemIcon>
                      <HomeIcon className={classes.menuIcon} />
                    </ListItemIcon>
                    Home
                  </MenuItem>
                  <MenuItem
                    onClick={handleMenuClose}
                    className={classes.menuItem}
                  >
                    <ListItemIcon>
                      <ServicesIcon className={classes.menuIcon} />
                    </ListItemIcon>
                    Services
                  </MenuItem>
                  <MenuItem
                    onClick={handleMenuClose}
                    className={classes.menuItem}
                  >
                    <ListItemIcon>
                      <SubjectsIcon className={classes.menuIcon} />
                    </ListItemIcon>
                    Subjects
                  </MenuItem>
                  <MenuItem
                    onClick={handleMenuClose}
                    className={classes.menuItem}
                  >
                    <ListItemIcon>
                      <ContactIcon className={classes.menuIcon} />
                    </ListItemIcon>
                    Contact
                  </MenuItem>
                  <Divider />
                  <MenuItem>
                    <Switch
                      checked={isDarkMode}
                      onChange={() => toggleDarkMode(!isDarkMode)}
                      name="darkModeToggle"
                      inputProps={{ "aria-label": "dark mode toggle" }}
                      color="primary"
                    />
                    Dark Mode
                  </MenuItem>
                </Menu>
              </Hidden>
              <img
                src="/assets/images/mbali_logo-removebg-preview.png"
                alt="Logo"
                className={classes.logo}
              />
              <Typography variant="h8" className={classes.title}>
                NgeMbalenhle Tutoring Services
              </Typography>
              <Hidden smDown>
                <Button color="inherit" className={classes.navButton}>
                  Home
                </Button>
                <Button color="inherit" className={classes.navButton}>
                  Services
                </Button>
                <Button color="inherit" className={classes.navButton}>
                  Subjects
                </Button>
                <Button color="inherit" className={classes.navButton}>
                  Contact
                </Button>
                <Divider orientation="vertical" className={classes.divider} />
                <Box className={classes.contactInfo}>
                  <PhoneIcon className={classes.contactIcon} />
                  <Typography variant="body2" className={classes.contactText}>
                    0677505304
                  </Typography>
                </Box>
                <Box className={classes.contactInfo}>
                  <EmailIcon className={classes.contactIcon} />
                  <Typography variant="body2" className={classes.contactText}>
                    ngembalenhle@gmail.com
                  </Typography>
                </Box>
                <Switch
                  checked={isDarkMode}
                  onChange={() => toggleDarkMode(!isDarkMode)}
                  name="darkModeToggle"
                  inputProps={{ "aria-label": "dark mode toggle" }}
                  color="primary"
                  className={classes.darkModeToggle}
                />
              </Hidden>
            </Toolbar>
          </Container>
        </AppBar>
      </Paper>
    </div>
  );
};

export default Header;
